import { useMutation, useQueryClient } from '@common-fe/common-fe';
import { toNumber } from 'lodash';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface Props {
  memberId?: string;
  teamsIds?: string[];
}

const useAssignTeamsToProcessorQuery = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation(
    (props: Props) =>
      api.put(API_URL.CONTACTS_CLAIMS_TEAMS_BY_CONTACT_ID(props.memberId || ''), {
        claims_teams_ids: [...new Set(props.teamsIds?.map((item) => toNumber(item)) || [])],
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [API_URL.CONTACTS_ALL],
        });
        if (onSuccess) {
          onSuccess();
        }
      },
    }
  );

  return mutateAsync;
};

export default useAssignTeamsToProcessorQuery;
